module.exports = __webpack_public_path__ + "static/media/2 กรณีลืมรหัสผ่าน_0.c68f4da6.jpg";